// import Breadcrumb from "@/components/atoms/breadcrumb/breadcrumb";
import './paymentReference.scss';
import { memo, useState } from 'react';

import CardConfirm from '@/components/molecules/card-confirm/cardConfirm';
import CardPaymentMethods from '@/components/molecules/card-payment-methods/cardPaymentMethods';

const MemoPaymentReference = ({ contentInfo, data, setCurrentStep }: any) => {
  const [checkedState, setCheckedState] = useState(new Array(data.length).fill(false));
  const onClickCardConfirmButton = () => {
    const indexPayment = checkedState.findIndex((item: any) => item === true);
    const dataPayment = {
      referenciaPago: data[indexPayment].referenciaPago,
      userDocument: data[indexPayment].identification,
      userDocumentType: data[indexPayment].identificationType.acronym,
    };

    localStorage.setItem('dataPayment', JSON.stringify(dataPayment));
    window.location.href =
      window.location.origin +
      (window?.location.hostname === 'localhost'
        ? '/pagos/pago-credito-personas'
        : '/portal-servicios/pagos/pago-credito-personas');
  };

  const handleCheckbox = (index: number) => {
    const updateCheckedState = checkedState.map((item, i) => {
      if (i === index) {
        return !item;
      }
      return false;
    });
    setCheckedState(updateCheckedState);
  };

  return (
    <div>
      <div>
        <CardConfirm
          onClickButton={onClickCardConfirmButton}
          content={contentInfo}
          numeroReferencia={data.map((item: any) => item.referenciaPago)}
          handleCheckbox={handleCheckbox}
          checkedState={checkedState}
          setCurrentStep={setCurrentStep}
        />
      </div>
      <div>
        <CardPaymentMethods content={contentInfo.referencias[3]} />
      </div>
    </div>
  );
};

const PaymentReference = memo(MemoPaymentReference);

export default PaymentReference;
